import localeLogin from '@/views/login/locale/en-US';
import localeHome from '@/views/down/locale/en-US';
import localeSettings from './zh-CN/settings';

export default {
  'menu.required': '请填写所有必填项',
  'menu.personal': '个人用户',
  'menu.locale': 'English',
  'menu.dark': '黑色模式',
  'menu.overview': 'Overview',
  'menu.accountsecurity': 'Account security',
  'menu.identityauthentication': 'Identity verification',
  'menu.paymentmethod': 'Payment methods',
  'menu.fundmanagement': 'Fund Management',
  'menu.balance': 'Balance',
  'menu.recharge': 'Recharge',
  'menu.buycoins': 'Buy coins',
  'menu.transferaccounts': 'Transfer',
  'menu.withdrawal': 'Withdrawal',
  'menu.recordquery': 'Record Query',
  'menu.c2corder': 'C2c Order',
  'menu.loginOut': 'Log out of login',
  'menu.payhis': 'Pay Historical Transactions',
  'menu.wallethistory': 'Wallet History',
  'menu.setupp': 'Settings',
  'navbar.action.locale': 'Switch to English',
  'public.next': '下一步',
  'public.submit': 'submit to',
  ...localeSettings,
  ...localeLogin,
  ...localeHome,
};

